import { KeycloakManagerEnvService } from '@aipb/gulliver/keycloak-manager/env';
import { KeycloakManagerRouting } from '@aipb/gulliver/keycloak-manager/routing';
import { ApplicationInitGuard } from '@aipb/gulliver/util-app';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class KeycloakManagerInitGuard extends ApplicationInitGuard {
  private keycloakManagerRouting = inject(KeycloakManagerRouting);

  constructor(protected keycloakManagerEnv: KeycloakManagerEnvService) {
    super('keycloak-manager', keycloakManagerEnv);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setup(): void {
    this.frame.setStaticRoutes([
      {
        url: this.keycloakManagerRouting.userDefaultRouteUrl(),
        label: 'keycloak_manager.routes.user_default',
        deletable: false,
        icon: 'person'
      }
    ]);
  }
}
